<template>
  <div>
    <div class="title">{{object.hyzt}}</div>
    <div style="padding: 0 12px; margin-bottom: 60px">
      <div class="desc"><span class="fbr">主持人：{{object.zcr}}</span><span class="fbr">记录人：{{object.jlr}}</span></div>
      <div class="desc"><span class="fbr">会议开始时间：{{object.hykssj}}</span></div>
      <div class="desc"><span class="fbr">参会人员：{{object.chry}}</span></div>
      <div class="desc"><span class="fbr">会议地点：{{object.hydd}}</span></div>
      <div v-html="object.hyyc" class="h5-html" @click="previewImage($event)" style="font-size:14px"></div> 
      <!-- <img v-if="object.tp" :src="object.tp" alt="" class="image"  @click="preViewImg(object.tp)"/> -->
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { ImagePreview } from 'vant'
import { addRandomAndGetPreviewImageUrlsFromRichText } from '@/utils/util'
// import bottomShare from '@/views/common/bottom-share.vue'
export default {
  // components: { bottomShare },
  data() {
    return {
      downOption: {
        auto: false, //是否在初始化后,自动执行downCallback; 默认true
      },
      params:this.$route.query,
      object:{},
      richImages:[],
      html:'',
     hylx_dictText:'',
    }
  },
  created() {
   this.getData();
  },
  mounted() {
  
  },
  methods: {
     getData() {
      getAction('/zhshj/djylztdrj/query/by/id',{id:this.params.id}).then((res) => {
        if (res.success) {
            let obj = res.result
            this.object = obj;
        }
      })
    },
    previewImage(e) {
      if (e.target.tagName == 'IMG') {
        ImagePreview({
          images: this.richImages,
          startPosition: e.target.src.split('random=')[1] - 1,
          closeOnPopstate: true, //页面回退关闭预览
        })
      }
    },
      preViewImg(img){
      let arr = [img];
      ImagePreview(arr);
    }
    
  },
}
</script>

<style lang="less" scoped>
/*说明*/
.title {
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 0 12px;
  margin-bottom: 10px;
}
.desc {
  color: #696969;
  margin-bottom: 12px;
  font-size: 14px;
}

.fbr {
  margin-right: 8px;
}

.time {
  margin-left: 8px;
}

.content {
  color: #303133;
  text-indent: 2em;
  line-height: 22px;
}

.bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.h5-html img {
  width: 100%;
}

.image{
  width: 100%;
}

.video{
  width: 100%;
  height: 180px;
  background: #303133;
}

</style>
